import { connectDataConnectEmulator, DataConnect, getDataConnect } from 'firebase/data-connect';
import { connectorConfig } from '../dataconnect-generated';

let instance: DataConnect | null = null;

/**
 * チャット用 Data Connect インスタンスを返す。
 * default の Firebase アプリ(App.tsx / AuthContext.tsx で初期化済み)を利用するため、
 * ログイン中ユーザーの IDトークン(JWT) はリクエストに自動で付与される。
 * モジュール読み込み順の影響を受けないよう遅延初期化にしている。
 */
export const getChatDataConnect = (): DataConnect => {
  if (!instance) {
    instance = getDataConnect(connectorConfig);
    if (process.env.REACT_APP_USE_DATACONNECT_EMULATOR === 'true') {
      connectDataConnectEmulator(instance, 'localhost', 9399);
    }
  }
  return instance;
};
